import { createApi } from '@reduxjs/toolkit/query/react'
import { MANAGE_STAFF_LIST, MANAGE_STAFF_ADD, MANAGE_STAFF_CLIENTS_LIST, MANAGE_STAFF_TASKS_LIST, MANAGE_STAFF_TASKS_LIST_LOOKUP, MANAGE_STAFF_DELETE_TASK, MANAGE_STAFF_CONSENT_LOOKUP, MANAGE_STAFF_ASSIGN_CONSENT_LOOKUP, MANAGE_STAFF_REMOVE_CONSENT_LOOKUP, MANAGE_STAFF_GROUPS_LIST, MANAGE_STAFF_GROUP_TASKS_LIST, MANAGE_STAFF_GROUP_TASKS_SESSION_VIEW, MANAGE_STAFF_TASK_STATUS_UPDATE, MANAGE_STAFF_GROUP_TASK_STATUS_UPDATE, MANAGE_STAFF_GET_POPULATE_TASKS_LIST, MANAGE_STAFF_UPDATE_CLIENT_ATTENDANCE, STAFF_TASKS_TEMPLATES_LIST, STAFF_TASKS_TEMPLATES_ADD, STAFF_TASKS_TEMPLATES_DELETE, STAFF_TASKS_TEMPLATES_VIEW, STAFF_TASKS_TEMPLATES_UPDATE, STAFF_TASKS_SUBMIT_SESSION, STAFF_GROUP_TASKS_SUBMIT_SESSION, STAFF_TASKS_SAVE_SESSION, STAFF_GROUP_TASKS_SAVE_SESSION, MANAGE_STAFF_GUARDIANS_LIST, MANAGE_STAFF_GUARDIAN_CLIENTS_LIST } from 'config/apiPaths';
import { generateCustomPath } from 'helpers/common';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const staffApi = createApi({
    reducerPath: 'staffApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/tasks",
    }),
    tagTypes: ["ConsentForms"],
    endpoints: (builder) => ({

        // staff list
        getStaffList: builder.query({
            query: ({ task_for = "", search = "", page = 1, limit = 10, taskType = "single", sort = { column: "id", direction: "ASC" }, client_type, school, grade }) => ({
                method: "PATCH",
                url: `${MANAGE_STAFF_LIST}`,
                data: { search, page, limit, sort, task_for, client_type, school: Number(school), grade }
            }),

            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ['staffListing']
        }),

        // create staff
        createStaff: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: MANAGE_STAFF_ADD,
                data
            }),
            invalidatesTags: ['staffList', 'staffListing']
        }),

        // staff clients list
        getStaffClientsList: builder.query({
            query: ({ id, taskType, payload = { search: "", page: 1, limit: 10, sort: { column: "id", direction: "ASC" } } }) => ({
                method: "PATCH",
                url: `${MANAGE_STAFF_CLIENTS_LIST}/${id}`,
                data: payload
            }),

            transformResponse: (response) => {
                return response.data;
            },
        }),

        // task list
        getStaffTaskList: builder.query({
            query: ({ id, taskType, clientId, payload = { search: "", page: 1, limit: 10, sort: { column: "id", direction: "ASC" } } }) => ({
                method: "PATCH",
                url: `${MANAGE_STAFF_TASKS_LIST}/${taskType}/${id}/${clientId}`,
                data: payload
            }),

            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ['staffList']
        }),


        // task list
        getClientTask: builder.query({
            query: ({ id, taskType, clientId, taskId, payload = { search: "", page: 1, limit: 10, sort: { column: "id", direction: "ASC" } } }) => ({
                method: "GET",
                url: `${MANAGE_STAFF_TASKS_LIST}/${taskType}/${id}/${clientId}/${taskId}`,
                data: payload
            })
        }),


        //Get Task sessin data
        getTaskSession: builder.mutation({
            query: ({ id, taskType, clientId, taskId, payload = {} }) => ({
                method: "POST",
                url: `/guardian/client/get-progress/${id}/${clientId}/${taskId}`,
                data: payload,
            }),
        }),
        //Get Task sessin data
        getTaskSessionStaff: builder.mutation({
            query: ({ id, taskType, clientId, taskId, payload = {} }) => ({
                method: "POST",
                url: `/staff/client/get-progress/${id}/${clientId}/${taskId}`,
                data: payload,
            }),
        }),

        //parent task details
        getTaskDetails: builder.query({
            query: ({ id, clientId, taskId }) => {
                return ({
                    method: "GET",
                    url: `/guardian/client/${id}/${clientId}/${taskId}`
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["TaskStatus"],
        }),

        //Staff task details
        getTaskDetailsStaff: builder.query({
            query: ({ id, clientId, taskId, taskType }) => {
                return ({
                    method: "GET",
                    url: `/staff/client/${taskType}/${id}/${clientId}/${taskId}`
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["TaskStatusStaff"],
        }),

        // task list lookup
        getStaffTaskListLookup: builder.query({
            query: () => ({
                method: "GET",
                url: MANAGE_STAFF_TASKS_LIST_LOOKUP
            }),

            transformResponse: (response) => {
                return response.data;
            },
        }),

        // delete task
        deleteTask: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${MANAGE_STAFF_DELETE_TASK}/${id}`,
            }),
        }),

        // guardians list
        getGuardiansList: builder.query({
            query: (id) => ({
                method: "GET",
                url: `/guardians/${id}`,
            }),

            transformResponse: (response) => {
                return response.data;
            }
        }),

        // consent form lookup
        consentFormLookup: builder.query({
            query: ({ clientId, guardianId }) => ({
                method: "GET",
                url: `${MANAGE_STAFF_CONSENT_LOOKUP}/${clientId}/${guardianId}`
            }),

            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ConsentForms"],
        }),

        // assign consent form
        assignConsentForm: builder.mutation({
            query: ({ clientId, guardianId, data }) => ({
                method: "PUT",
                url: `${MANAGE_STAFF_ASSIGN_CONSENT_LOOKUP}/${clientId}/${guardianId}`,
                data
            }),
            invalidatesTags: ["ConsentForms"]
        }),

        // remove consent form
        removeConsentForm: builder.mutation({
            query: ({ clientId, guardianId, formId }) => ({
                method: "DELETE",
                url: `${MANAGE_STAFF_REMOVE_CONSENT_LOOKUP}/${clientId}/${guardianId}/${formId}`
            }),
            invalidatesTags: ["ConsentForms"]
        }),
        //UPDATE TASK STATUS
        markTaskComplete: builder.mutation({
            query: ({ task_id, owner, updateStatus }) => ({
                url: `/status/update/${task_id}/${owner}/${updateStatus}`,
                method: 'PUT',
            }),
            invalidatesTags: ["TaskStatus", 'staffGroupSessionView']
        }),

        //UPDATE SINGLE TASK STATUS
        taskStatusUpdate: builder.mutation({
            query: ({ id, status }) => ({
                url: `${MANAGE_STAFF_TASK_STATUS_UPDATE}/${id}/${status}`,
                method: 'PUT',
            }),
            // invalidatesTags: ["TaskStatus", "TaskStatusStaff", 'staffGroupSessionView']
        }),

        //UPDATE GROUP TASK STATUS
        groupTaskStatusUpdate: builder.mutation({
            query: ({ staffId, groupId, status, task_datetime }) => ({
                url: `${MANAGE_STAFF_GROUP_TASK_STATUS_UPDATE}/${staffId}/${groupId}/${status}`,
                method: 'PATCH',
                data: { task_datetime }
            }),
            invalidatesTags: ["staffGroupSessionView"]
        }),


        getStaffGroupsList: builder.query({
            query: ({ id, payload = { search: "", page: 1, limit: 10, sort: { column: "id", direction: "ASC" } } }) => ({
                method: "PATCH",
                url: `${MANAGE_STAFF_GROUPS_LIST}/${id}`,
                data: payload
            }),

            transformResponse: (response) => {
                return response.data;
            },
        }),

        getStaffGroupsTasksList: builder.query({
            query: ({ staffId, groupId, payload = { search: "", page: 1, limit: 10, sort: { column: "id", direction: "ASC" } } }) => ({
                method: "GET",
                url: `${MANAGE_STAFF_GROUP_TASKS_LIST}/${staffId}/${groupId}`,
                data: payload
            }),

            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ['staffGroupSessionView']
        }),

        getStaffGroupSessionView: builder.query({
            query: ({ staffId, groupId, task_datetime, payload = { search: "", page: 1, limit: 10, sort: { column: "id", direction: "ASC" } } }) => ({
                method: "PATCH",
                url: `${MANAGE_STAFF_GROUP_TASKS_SESSION_VIEW}/${staffId}/${groupId}`,
                data: { task_datetime }
            }),

            transformResponse: (response) => {
                return response.data;
            },
        }),

        getPopulatedTasksList: builder.query({
            query: ({ search }) => ({
                method: "GET",
                url: `/${MANAGE_STAFF_GET_POPULATE_TASKS_LIST}/${search}`,
            }),

            transformResponse: (response) => {
                return response.data;
            },
        }),

        staffClientAttendanceUpdate: builder.mutation({
            query: ({ id, attendance }) => ({
                method: "PUT",
                url: `${MANAGE_STAFF_UPDATE_CLIENT_ATTENDANCE}/${id}/${attendance}`,
            }),
        }),

        // CRUD OF TASK TEMPLATES STARTS 
        getStaffListTaskTemplates: builder.query({
            query: ({ task_for = "", search = "", page = 1, limit = 10, taskType = "single", sort = { /*column: "id", direction: "ASC"*/ }, client_type, school, grade }) => ({
                method: "PATCH",
                url: `${STAFF_TASKS_TEMPLATES_LIST}`,
                data: { search, page, limit, sort }
            }),

            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ['staffTasksTemplateListing']
        }),

        createStaffTaskTemplate: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: STAFF_TASKS_TEMPLATES_ADD,
                data
            }),
            invalidatesTags: ['staffTasksTemplateListing']
        }),

        deleteStaffTaskTemplate: builder.mutation({
            query: ({ id }) => ({
                method: "DELETE",
                url: `${STAFF_TASKS_TEMPLATES_DELETE}/${id}`,
            }),
            invalidatesTags: ['staffTasksTemplateListing']
        }),

        viewStaffTaskTemplate: builder.query({
            query: ({ id }) => ({
                method: "GET",
                url: `${STAFF_TASKS_TEMPLATES_VIEW}/${id}`,
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ['viewTaskTemplate']
        }),

        updateStaffTaskTemplate: builder.mutation({
            query: ({ id, data }) => ({
                method: "PATCH",
                url: `${STAFF_TASKS_TEMPLATES_UPDATE}/${id}`,
                data
            }),
            invalidatesTags: ['viewTaskTemplate', 'staffTasksTemplateListing']
        }),

        // TASK SUBMISSION
        submitSingleStaffTask: builder.mutation({
            query: ({ taskId, clientId, staffId, data }) => ({
                url: generateCustomPath(STAFF_TASKS_SUBMIT_SESSION, { taskId, staffId, clientId }),
                method: 'POST',
                data
            }),
            transformResponse: (response) => {
                return response?.data;
            },
            // invalidatesTags: ["TaskProgress", "ClientTaskList", "TaskGroups"],
        }),

        submitGroupStaffTask: builder.mutation({
            query: ({ staffId, taskId, payload }) => ({
                url: generateCustomPath(STAFF_GROUP_TASKS_SUBMIT_SESSION, { staffId, taskId }),
                method: 'POST',
                data: payload
            }),
            // invalidatesTags: ["TaskGroupProgress", "TaskGroups"],
        }),


        // TASK SAVE
        saveSingleStaffTask: builder.mutation({
            query: ({ taskId, clientId, staffId, data }) => ({
                url: generateCustomPath(STAFF_TASKS_SAVE_SESSION, { taskId, staffId, clientId }),
                method: 'POST',
                data
            }),
            transformResponse: (response) => {
                return response?.data;
            },
            // invalidatesTags: ["TaskProgress", "ClientTaskList", "TaskGroups"],
        }),

        saveGroupStaffTask: builder.mutation({
            query: ({ staffId, taskId, payload }) => ({
                url: generateCustomPath(STAFF_GROUP_TASKS_SAVE_SESSION, { staffId, taskId }),
                method: 'POST',
                data: payload
            }),
            // invalidatesTags: ["TaskGroupProgress", "TaskGroups"],
        }),

        getTasksGuardiansList: builder.query({
            query: ({ search = "", page = 1, limit = 10, sort = { "column": "id", "direction": "desc" }, task_for = "parent", school = null }) => ({
                method: "PATCH",
                url: `${MANAGE_STAFF_GUARDIANS_LIST}`,
                data: { search, page, limit, sort, task_for, school }
            }),

            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ['getTaskGuardiansList']
        }),

        getParentTasksClientsList: builder.query({
            query: ({ id, page = 1, limit = 10, search, sort = { column: "id", direction: "desc" } }) => ({
                method: "PATCH",
                url: `${MANAGE_STAFF_GUARDIAN_CLIENTS_LIST}/${id}`,
                data: { search, page, limit, sort }
            }),

            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ['getParnetTaskGuardiansList']
        }),


    })
})

export const {
    useGetStaffListQuery,
    useCreateStaffMutation,
    useGetStaffClientsListQuery,
    useGetStaffTaskListQuery,
    useGetStaffTaskListLookupQuery,
    useDeleteTaskMutation,
    useLazyGetGuardiansListQuery,
    useConsentFormLookupQuery,
    useAssignConsentFormMutation,
    useRemoveConsentFormMutation,
    useGetClientTaskQuery,
    useGetTaskSessionMutation,
    // useGetStaffTaskSessionMutation,
    useGetTaskDetailsQuery,
    useGetTaskDetailsStaffQuery,
    useLazyGetTaskDetailsStaffQuery,
    useGetTaskSessionStaffMutation,
    useMarkTaskCompleteMutation,
    useGetStaffGroupsListQuery,
    useGetStaffGroupsTasksListQuery,
    useGetStaffGroupSessionViewQuery,
    useTaskStatusUpdateMutation,
    useGroupTaskStatusUpdateMutation,
    useLazyGetPopulatedTasksListQuery,
    useStaffClientAttendanceUpdateMutation,
    useGetStaffListTaskTemplatesQuery,
    useLazyGetStaffListTaskTemplatesQuery,
    useCreateStaffTaskTemplateMutation,
    useDeleteStaffTaskTemplateMutation,
    useViewStaffTaskTemplateQuery,
    useUpdateStaffTaskTemplateMutation,
    useSubmitSingleStaffTaskMutation,
    useSubmitGroupStaffTaskMutation,
    useSaveSingleStaffTaskMutation,
    useSaveGroupStaffTaskMutation,
    useGetTasksGuardiansListQuery,
    useGetParentTasksClientsListQuery
} = staffApi;